import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/content";

export const StickyBar = ({ config }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-900/10 bg-ivory/95 p-3 backdrop-blur-md sm:hidden"
          data-testid="mobile-sticky-whatsapp-bar"
        >
          <a
            data-testid="mobile-sticky-whatsapp-cta"
            href={waLink(config.whatsapp_number, config.whatsapp_default_message)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-ink py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory"
          >
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-60" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#25D366]" />
            </span>
            <MessageCircle size={15} />
            Direct Inquiry
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
